import { render } from "./About.vue?vue&type=template&id=fef4f39a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "@/assets/css/layout.css?vue&type=style&index=0&id=fef4f39a&scoped=true&lang=css"
import "@/assets/css/about.css?vue&type=style&index=1&id=fef4f39a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef4f39a"]])

export default __exports__